/* eslint-disable workbench/tag-name-transform */
export const COMPONENT_TAG = 'wb-radio-button';
